import { fetchInstagramThumbnailUrl } from 'utils/content/instagram-gql-fallback';
import { getTikTokThumbnailUrlFromVideoUrl } from 'utils/tiktok-thumbnail';

import type { PostAlike } from 'types';

// used same signature as other thumbnail functions
export function getInstagramThumbnailUrl<T extends PostAlike>(
  _: string,
  __: string,
  post: T
): Promise<string> {
  const postUrl = post.imageUrl || post.url;

  return fetchInstagramThumbnailUrl(postUrl ?? '', '', post.assetUrl ?? '');
}

export async function extendWithInstagramThumbnailUrl<T extends PostAlike>(item: T): Promise<T> {
  try {
    const newUrl = await getInstagramThumbnailUrl('', '', item);
    return {
      ...item,
      assetUrl: newUrl
    };
  } catch {
    return item;
  }
}

export async function extendWithTikTokThumbnailUrl<T extends PostAlike>(item: T): Promise<T> {
  try {
    const newUrl = await getTikTokThumbnailUrlFromVideoUrl(item.url ?? '');
    return {
      ...item,
      imageUrl: newUrl,
      assetUrl: newUrl
    };
  } catch {
    return item;
  }
}
